import type { AnalyticsEventPayload, UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { ProformaReqTypeAddError } from '@atlassian/jira-proforma-request-type-config/src/common/utils/error-types/add/index.tsx';
import { addProformaReqTypeForm as internalFetch } from '@atlassian/jira-proforma-request-type-config/src/services/add-proforma-rtc/main.tsx';
import type { ProformaReqTypeFormAddRequest } from '@atlassian/jira-proforma-request-type-config/src/services/add-proforma-rtc/types.tsx';

export const addProformaReqTypeForm = async (
	proformaReqTypeFormAddRequest?: ProformaReqTypeFormAddRequest,
	createAnalyticsEvent?: (payload: AnalyticsEventPayload) => UIAnalyticsEvent,
): Promise<number | undefined> => {
	if (proformaReqTypeFormAddRequest) {
		try {
			return await internalFetch({ ...proformaReqTypeFormAddRequest, createAnalyticsEvent });
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			throw new ProformaReqTypeAddError(e.message, proformaReqTypeFormAddRequest.formName);
		}
	}
	return undefined;
};
